var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-full h-full flex-column align-center justify-center"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }